// src/pages/WelcomeScreenPage.tsx
import React, { useState, useEffect } from "react";
import WelcomeScreenView from "./welcome_screen.view";
import api from "../../api/axiosConfig";
import "../../center admin css/centerAdmin.css";

/* ================== Types (exported for welcome_screen.view.tsx) ================== */

interface UserProfile {
  _id: string;
  displayName: string;
  email: string;
  centerAssignments?: { centerId: string }[];
}

export interface IUser {
  userId: string;
  userName: string;
}
export interface IStation {
  stationId: string;
  stationName: string;
  users: IUser[];
}
export interface ICenterConfig {
  _id: string;
  appointmentClusterId: string;
  centerId: string;
  centerName: string;
  stations: IStation[];
}

export interface IScheduleDetails {
  slotDesigns: { [weekday: string]: string };
  totalSlots: number;
  screeningStartDate: string; // DD-MM-YYYY
  screeningEndDate: string; // DD-MM-YYYY
  totalScreeningDays: number; // from backend (we also recompute locally)
}

export interface IScreeningCounts {
  totalBookingsToday: number;
  totalCompletedToday: number;
  totalPendingToday: number;
}

/** Read the cached user written by MainApp/others. */
function readCachedUser(): UserProfile | null {
  const keys = ["backendResponse", "CurrrentResponse", "CurrentResponse"];
  for (const k of keys) {
    try {
      const raw = sessionStorage.getItem(k);
      if (raw) return JSON.parse(raw) as UserProfile;
    } catch {
      // ignore and try next key
    }
  }
  return null;
}

/* ================== Page ================== */

const WelcomeScreenPage: React.FC = () => {
  const [userProfile, setUserProfile] = useState<UserProfile | null>(null);
  const [centerConfig, setCenterConfig] = useState<ICenterConfig | null>(null);
  const [scheduleDetails, setScheduleDetails] =
    useState<IScheduleDetails | null>(null);
  const [screeningCounts, setScreeningCounts] =
    useState<IScreeningCounts | null>(null);

  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [showEditTeamModal, setShowEditTeamModal] = useState(false);

  const [editedStations, setEditedStations] = useState<IStation[]>([]);

  const loadScreenData = async () => {
    setLoading(true);
    setError(null);

    try {
      const cached = readCachedUser();

      if (!cached) {
        throw new Error("User profile not found in session storage.");
      }

      setUserProfile(cached);

      const token = sessionStorage.getItem("accessToken");

      if (!token) {
        throw new Error("No access token found.");
      }

      const authHeaders = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const assignedCenterId = sessionStorage.getItem("centerId");

      if (!assignedCenterId) {
        throw new Error("No selected centerId found.");
      }

      const centerCfgUrl = `/api/v1/center/${assignedCenterId}/config`;

      // const centerRes = await api.center_api.get<{
      //   data: ICenterConfig;
      // }>(centerCfgUrl, authHeaders);

      const centerRes = await api.center_api.get<{
        data: ICenterConfig[];
      }>(centerCfgUrl, authHeaders);

      console.log("CENTER CONFIG RESPONSE:", centerRes.data);

      // const cfg = centerRes.data?.data;
      const cfg = centerRes.data?.data?.[0];

      console.log("EXTRACTED CENTER CONFIG:", cfg);

      if (!cfg?.centerId) {
        throw new Error("Center config missing centerId.");
      }

      setCenterConfig(cfg);

      const scheduleUrl = `/api/appointments/screening/details/${assignedCenterId}`;

      const scheduleRes = await api.appointment_api.get<IScheduleDetails>(
        scheduleUrl,
        authHeaders,
      );

      setScheduleDetails(scheduleRes.data);

      const countsUrl = `/api/appointments/screening/counts/${cfg.centerId}`;

      const countsRes = await api.appointment_api.get<IScreeningCounts>(
        countsUrl,
        authHeaders,
      );

      setScreeningCounts(countsRes.data);
    } catch (err) {
      console.error(err);
      setError("Could not load all screening details.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadScreenData();
  }, []);

  const refreshCenterConfig = async () => {
    try {
      const token = sessionStorage.getItem("accessToken");

      const assignedCenterId = sessionStorage.getItem("centerId");

      const authHeaders = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await api.center_api.get<{
        data: ICenterConfig;
      }>(`/api/v1/center/${assignedCenterId}/config`, authHeaders);

      setCenterConfig(response.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  const displayName = userProfile
    ? userProfile.displayName
    : loading
      ? "..."
      : "Guest";

  return (
    // <WelcomeScreenView
    //   userName={displayName}
    //   centerConfig={centerConfig}
    //   scheduleDetails={scheduleDetails}
    //   screeningCounts={screeningCounts}
    //   isLoading={loading}
    //   error={error}
    // />
    <WelcomeScreenView
      userName={displayName}
      centerConfig={centerConfig}
      scheduleDetails={scheduleDetails}
      screeningCounts={screeningCounts}
      isLoading={loading}
      error={error}
      showEditTeamModal={showEditTeamModal}
      setShowEditTeamModal={setShowEditTeamModal}
      editedStations={editedStations}
      setEditedStations={setEditedStations}
      refreshCenterConfig={refreshCenterConfig}
    />
  );
};

export default WelcomeScreenPage;
